import * as React from "react";
import { IconProps } from "ztypes/icon-props";

const IconRocket1: React.FunctionComponent<IconProps> = (props) => {
  return (
    <svg
      className={props.className}
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.0941 18.7178L9.2832 12.9069L16.7471 5.44302C17.7232 4.46655 18.9519 3.78123 20.2956 3.4639C21.6393 3.14656 23.0449 3.20974 24.3547 3.64635C24.7913 4.95616 24.8545 6.3617 24.5371 7.7054C24.2198 9.0491 23.5345 10.2779 22.558 11.254L15.0941 18.7178Z"
        stroke="#0068FF"
        strokeWidth="1.54"
        strokeMiterlimit="10"
      />
      <path
        d="M19.4535 9.64653C20.061 9.64653 20.5535 9.15405 20.5535 8.54653C20.5535 7.93902 20.061 7.44653 19.4535 7.44653C18.846 7.44653 18.3535 7.93902 18.3535 8.54653C18.3535 9.15405 18.846 9.64653 19.4535 9.64653Z"
        fill="#0068FF"
      />
      <path
        d="M11.4582 19.4467L8.55273 16.5412L10.0106 13.6357L14.3637 17.9888L11.4582 19.4467Z"
        stroke="#0068FF"
        strokeWidth="1.54"
        strokeMiterlimit="10"
      />
      <path
        d="M17.9961 15.8171C18.3774 16.1985 18.6799 16.6512 18.8863 17.1494C19.0927 17.6477 19.1989 18.1817 19.1989 18.721C19.1989 19.2603 19.0927 19.7943 18.8863 20.2925C18.6799 20.7908 18.3774 21.2435 17.9961 21.6248L15.8182 23.8027C15.0481 23.0326 14.6154 21.988 14.6154 20.8989C14.6154 19.8097 15.0481 18.7652 15.8182 17.995L17.9961 15.8171Z"
        stroke="#0068FF"
        strokeWidth="1.54"
        strokeMiterlimit="10"
      />
      <path
        d="M4.20162 12.1916L6.37951 10.0137C7.14966 9.24357 8.1942 8.8109 9.28336 8.8109C10.3725 8.8109 11.4171 9.24357 12.1872 10.0137L10.0093 12.1916C9.23917 12.9618 8.19462 13.3944 7.10547 13.3944C6.01631 13.3944 4.97177 12.9618 4.20162 12.1916Z"
        stroke="#0068FF"
        strokeWidth="1.54"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default IconRocket1;
